import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PredictorPageComponent } from './pages/predictor-page/predictor-page.component';
import { StudyAreaResolver } from './resolvers/study-area-resolver';
import { SimulationsPageComponent } from './pages/simulations-page/simulations-page.component';
import { SimulationTrackerResolver } from './resolvers/simulation-tracker.resolver';
import { SimulationResultPageComponent } from './pages/simulation-result-page/simulation-result-page.component';
import { SimulationTrackersResolver } from './resolvers/simultation-trackers.resolver';
import { SimulationTrackerReportPageComponent } from './pages/simulation-tracker-report-page/simulation-tracker-report-page.component';
const predictorRoutes: Routes = [
  {
    path: 'predictor',
    component: PredictorPageComponent,
  },
  {
    path: 'simulations',
    component: SimulationsPageComponent,
    resolve: {
      simulationTracker: SimulationTrackersResolver,
    },
  },
  {
    path: 'simulations/usage-report',
    component: SimulationTrackerReportPageComponent,
    resolve: {
      simulationTracker: SimulationTrackersResolver,
    },
  },
  {
    path: 'predictor/:id/simulation-results/:simulationTrackerId',
    component: SimulationResultPageComponent,
    resolve: {
      studyArea: StudyAreaResolver,
      tracker: SimulationTrackerResolver,
    },
  },
  {
    path: 'predictor/:id',
    component: PredictorPageComponent,
    resolve: {
      studyArea: StudyAreaResolver,
    },
  },
  {
    path: 'manage-enterprises-license',
    loadChildren: () =>
      import(
        '../predictor-enterprise-license/enterprise-license-admin/enterprise-license-admin.module'
      ).then((m) => m.EnterpriseLicenseAdminModule),
  },
  {
    path: 'enterprises-license-details',
    loadChildren: () =>
      import(
        '../predictor-enterprise-license/enterprise-license-manager/enterprise-license-manager.module'
      ).then((m) => m.EnterpriseLicenseManagerModule),
  },
  {
    path: 'create-study-area',
    loadChildren: () =>
      import(
        '../predictor-enterprise-license/create-study-area/create-study-area.module'
      ).then((m) => m.CreateStudyAreaModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(predictorRoutes)],
  exports: [RouterModule],
})
export class PredictorRoutingModule {}
